import type { TimelineElement } from '../context/TimelineContext'
import type { TimelineBoardKey } from '../types/schema'

type ChatContextPromptInput = {
  board: TimelineBoardKey
  goal: TimelineElement | null
  task: TimelineElement | null
  subtask: TimelineElement | null
}

const describeElement = (label: string, element: TimelineElement | null) =>
  element ? `${label} [${element.title}] (ID: ${element.id})` : `${label}: none`

export const getContextPrompt = ({ board, goal, task, subtask }: ChatContextPromptInput): string => [
  `Current board: ${board}`,
  describeElement('Goal', goal),
  describeElement('Task', task),
  describeElement('Subtask', subtask),
].join('. ')
